import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: "c6f69800-9ee2-4ab0-be85-8075f56536c0",
    authority: "https://login.microsoftonline.com/common",
    // The redirect response is always handled on this registered redirect URI. MSAL v5 removed
    // navigateToLoginRequestUrl, so it does NOT bounce back to the originating page — we carry the
    // origin in the `state` param and navigate back ourselves. See loginWithMicrosoft + onDecision.
    redirectUri: window.location.origin + "/account/login",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// Microsoft Graph scope used to read the tenant's organization display name (e.g. "SSA Group").
// Acquired separately AFTER login so login itself never depends on it. Delegated
// Organization.Read.All requires tenant-admin consent — without it, the silent token request fails
// and we fall back to the email-domain label.
export const graphOrgRequest = {
  scopes: ["Organization.Read.All"],
};
